const AI_BASE_PATH = '/aiMode'
const AI_HOME_PATH = '/aiMode/selectCategory'
const FALLBACK_PATH = '/Selection'

export const openAiSection = (history) => {
    const { pathname, search, state } = history.location
    const aiReturnTo = pathname.startsWith(AI_BASE_PATH)
        ? state && state.aiReturnTo
        : pathname + search
    history.push(AI_HOME_PATH, aiReturnTo ? { aiReturnTo } : undefined)
}

export const leaveAiSection = (history) => {
    const state = history.location.state
    if (state && state.aiReturnTo) {
        history.goBack()
    } else {
        history.replace(FALLBACK_PATH)
    }
}

const TRAINING_PATH = '/chooseTrainingDevice'

export const openAiTraining = (history) => {
    const state = history.location.state
    history.push(TRAINING_PATH, {
        fromAiHome: true,
        ...(state && state.aiReturnTo ? { aiReturnTo: state.aiReturnTo } : {}),
    })
}

export const leaveAiTraining = (history) => {
    const state = history.location.state
    if (state && state.fromAiHome) {
        history.goBack()
    } else {
        history.push(AI_HOME_PATH)
    }
}

export const openAiTrainingMode = (history, path) => {
    history.push(path, { fromTrainingDevice: true })
}

export const leaveAiTrainingMode = (history) => {
    const state = history.location.state
    if (state && state.fromTrainingDevice) {
        history.goBack()
    } else {
        history.replace(TRAINING_PATH)
    }
}
